var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ribbon',{staticClass:"has-background-white"},[_c('u-padding',{attrs:{"y":false}},[_c('horizontal-nav',{attrs:{"is-borderless":true,"routes":_vm.routes}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }